import script from "./project-person-fail-table.vue?vue&type=script&lang=tsx&setup=true"
export * from "./project-person-fail-table.vue?vue&type=script&lang=tsx&setup=true"

import "./project-person-fail-table.vue?vue&type=style&index=0&id=61ec24b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ec24b2"]])

export default __exports__